export default {
    methods: {
        blockUI() {
            let hash = window.performance.now().toString();
            this.$eventBus.$emit('loader.show', {
                hash
            });
            return hash;
        },
        unblockUI(hash) {
            setTimeout(() => {
                this.$eventBus.$emit('loader.hide', hash)
            }, 200);
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/loader.js